module.exports = "//d274d294w9cx2v.cloudfront.net/0ebc0a9c7e8eb4bdb8442f918f68687302387325/images/payPalBadge.png";